import { Card, CardContent } from '../ui/card';
import { Target, CheckCircle2, Repeat, Clock } from 'lucide-react';

const STATS = [
  { key: 'total_interests', label: 'Active Interests', icon: Target, color: 'emerald' },
  { key: 'total_achievements', label: 'Achievements', icon: CheckCircle2, color: 'blue' },
  { key: 'total_movements', label: 'Movements', icon: Repeat, color: 'amber' },
  { key: 'avg_time_to_achieve_hours', label: 'Avg. Completion', icon: Clock, color: 'purple', suffix: 'h' }
];

const COLOR_MAP = {
  emerald: 'bg-emerald-100 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-400',
  blue: 'bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400',
  amber: 'bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400',
  purple: 'bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400'
};

export const StatsGrid = ({ summary }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
    {STATS.map(({ key, label, icon: Icon, color, suffix }) => (
      <Card key={key} className="glass border-white/20 dark:border-white/10">
        <CardContent className="pt-6">
          <div className="flex items-center gap-3">
            <div className={`p-2 rounded-lg ${COLOR_MAP[color]}`}>
              <Icon className="w-5 h-5" />
            </div>
            <div>
              <p className="text-2xl font-bold">{summary?.[key] || 0}{suffix || ''}</p>
              <p className="text-sm text-muted-foreground">{label}</p>
            </div>
          </div>
        </CardContent>
      </Card>
    ))}
  </div>
);
